export const LIBRARY_SORT_DIRECTIONS = ["asc", "desc"] as const;

export type LibrarySortDirection = (typeof LIBRARY_SORT_DIRECTIONS)[number];

export function parseLibrarySortDirection(
  value: string | undefined,
): LibrarySortDirection {
  return value === "asc" ? "asc" : "desc";
}

export function appendLibrarySortParams(
  params: URLSearchParams,
  sort: { column: string; direction: LibrarySortDirection } | null | undefined,
): void {
  if (!sort) return;

  params.set("sort", sort.column);
  params.set("dir", sort.direction);
}

export function getNextLibrarySort<C extends string>(
  current: { column: C; direction: LibrarySortDirection } | null,
  column: C,
): { column: C; direction: LibrarySortDirection } {
  if (current?.column === column) {
    return {
      column,
      direction: current.direction === "asc" ? "desc" : "asc",
    };
  }

  return { column, direction: "asc" };
}
